import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  total_sales: 0,
};

const dashBoardTotalSalesReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_TOTAL_SALES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Roles fetch successfully",
        total_sales: action.payload.data,
      };
    case TYPE.GET_TOTAL_SALES_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching roles",
        total_sales: 0,
      };

    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default dashBoardTotalSalesReducer;
